import { render } from "./miniRewardsBanner.vue?vue&type=template&id=834fd89a&ts=true"
import script from "./miniRewardsBanner.vue?vue&type=script&lang=ts"
export * from "./miniRewardsBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__